// @ts-check
// Item "E-mail de marketing" na linha do tempo da pessoa, do card e da família (spec/email.md seção 16.1; contrato 09
// de e-mail, seção 17): o assunto gravado no envio, a campanha ou o fluxo de origem (o link só com a flag de cada um) e
// as marcas Abriu (estimado quando só a proteção de privacidade abriu), Clicou, Devolvido e Descadastrou.
import { html } from 'htm/preact';
import { Link } from '../../app/router.js';
import { formatDateTime, formatRelativeToNow } from '../../lib/format.js';
import { describeEmailMarketingEvent } from '../../lib/email-campaigns.js';
import { Icon } from '../../ui/icon.js';
import { t } from '../../i18n/index.js';

/** @param {{ event: any, isLast: boolean }} props */
export function EmailMarketingTimelineEvent({ event, isLast }) {
  const properties = event.properties ?? {};
  const { text, href, linkLabel } = describeEmailMarketingEvent(properties, t);
  /** @type {Array<{ key: string, tone: string }>} */
  const marks = [];
  if (properties.firstOpenedAt) marks.push({ key: properties.isOpenEstimated ? 'openedEstimated' : 'opened', tone: properties.isOpenEstimated ? 'blue' : 'green' });
  if (properties.firstClickedAt) marks.push({ key: 'clicked', tone: 'green' });
  if (properties.bounced) marks.push({ key: 'bounced', tone: 'orange' });
  if (properties.unsubscribedAt) marks.push({ key: 'unsubscribed', tone: 'orange' });
  return html`<div class="timeline-event" data-last=${isLast ? 'true' : undefined} data-kind="emailMarketing" data-testid="timeline-email-marketing">
    <div class="timeline-event-icon"><${Icon} name="IconMailForward" size=${16} /></div>
    <div class="timeline-event-content">
      <div class="timeline-event-line">
        <span class="timeline-event-sentence">${text}${href ? html` <${Link} href=${href} className="ec-link">${linkLabel}<//>` : null}</span>
        <span class="timeline-event-date" title=${formatDateTime(event.happensAt)}>${formatRelativeToNow(event.happensAt)}</span>
      </div>
      ${marks.length > 0
        ? html`<div class="ec-timeline-marks">${marks.map((mark) => html`<span key=${mark.key} class="ec-badge" data-tone=${mark.tone}>${t(`timeline.emailMarketing.${mark.key}`)}</span>`)}</div>`
        : null}
    </div>
  </div>`;
}
